<template>
  <div class="animated fadeIn">
    <div class="card" v-if="MethodService.checkHaveFeature('FT2101')">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Quản lý hợp đồng</h4>
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search">
            <el-form
              ref="saerchForm"
              :model="mData.tableRules.dataSearch.value"
              :rules="mData.tableRules.dataSearch.valid"
              label-position="left"
              label-width="130px"
              @submit.native.prevent
            >
              <b-row>
                <b-col md="4">
                  <el-form-item label="Tên văn bản">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.name"
                        @change="() => {mData.tableRules.dataSearch.value.name = mData.tableRules.dataSearch.value.name.trim()}"
                        clearable
                      ></el-input>
                    </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Số hợp đồng" prop="code">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.code"
                        @change="() => {mData.tableRules.dataSearch.value.code = mData.tableRules.dataSearch.value.code.trim()}"
                        clearable
                      ></el-input>
                    </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Loại văn bản">
                    <el-select
                      v-model="mData.tableRules.dataSearch.value.type"
                      clearable
                      placeholder="Chọn"
                    >
                      <el-option
                        v-for="(item,index) in mData.dataDefault.listTypes"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12" class="text-center">
                  <el-button
                    round
                    class="btn-default"
                    native-type="submit"
                    @click="tableSearch()"
                  >
                    Tìm kiếm
                  </el-button>
                  <el-button
                    round
                    class="btn-default"
                    @click="handle('create')"
                    v-if="mData.dataDefault.listFeature.includes('FT2102')"
                  >
                    Thêm mới
                  </el-button>
                </b-col>
              </b-row>
            </el-form>
          </div>
          <div class="main-body__table mt-3">
            <el-table
              :data="mData.tableRules.data"
              border
              style="width: 100%"
              max-height="500"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="type"
                label="Loại"
                width="120"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.type == "CONTRACT" ? 'Hợp đồng' : 'Văn bản'
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="Nhân viên"
                min-width="140"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="getEmployee(scope.row.employee_id || '')"
                  >
                    <span class="content" slot="reference">{{
                      getEmployee(scope.row.employee_id || "")
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Tên văn bản"
                min-width="140"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.name"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.name
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="code"
                label="Số hợp đồng"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.code"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.code
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="effective_date"
                label="Ngày hiệu lực"
                width="120"
              >
                <template slot-scope="scope">
                  {{
                    formatDate(scope.row.effective_date || "")
                  }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="expiration_date"
                label="Ngày hết hiệu lực"
                width="125"
              >
                <template slot-scope="scope">
                  {{
                    formatDate(scope.row.expiration_date || "")
                  }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="Thao tác"
                width="180"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="MethodService.checkHaveFeature('FT2102')"
                    size="mini"
                    plain
                    round
                    @click="handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    :disabled="!mData.dataDefault.listFeature.includes('FT1802')"
                  >
                    <i class="isax-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="handle('download', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_download"
                    :disabled="!mData.dataDefault.listFeature.includes('FT1805') || (scope.row.file_ids && scope.row.file_ids.length == 0)"
                  >
                    <i class="isax-document-download"></i>
                  </el-button>
                  <el-button
                    v-if="MethodService.checkHaveFeature('FT2103')"
                    size="mini"
                    plain
                    round
                    @click="handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                    :disabled="!mData.dataDefault.listFeature.includes('FT1803')"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2">
              <b-col md="2"></b-col>
              <b-col md="10" class="text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="mData.viewMode == 'create' ? 'Thêm mới' : 'Cập nhật'"
      :visible.sync="mData.visibleDialog"
      top="50px"
      width="710px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="form-dialog"
    >
      <div class="form">
        <el-form
          ref="myForm"
          :model="mData.dataForm"
          :rules="mData.validForm"
          label-position="left"
          label-width="160px"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Loại văn bản" prop="type">
                <el-select
                  v-model="mData.dataForm.type"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  placeholder="Chọn"
                  @change="onTypeChange"
                >
                  <el-option
                    v-for="(item,index) in mData.dataDefault.listTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Tên văn bản" prop="name">
                <el-input
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @change="() => {mData.dataForm.name = mData.dataForm.name.trim()}"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Số văn bản" prop="code" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-input
                  v-model="mData.dataForm.code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @change="() => {mData.dataForm.code = mData.dataForm.code.trim()}"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Nhân viên" prop="employee_id">
                <el-select
                  v-model="mData.dataForm.employee_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                  placeholder="Chọn"
                >
                  <el-option
                    v-for="(item,index) in mData.dataDefault.listEmployees"
                    :key="index"
                    :label="`${item.employee_no} - ${item.administrative_info.name.full_name}`"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ngày hiệu lực" prop="effective_date" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-date-picker
                  type="date"
                  ref="EffectiveDate"
                  v-model="mData.dataForm.effective_date"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="false"
                  placeholder=""
                  prefix-icon="isax-calendar-1"
                  :format="'dd/MM/yyyy'"
                  @change="checkValidDate"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ngày hết hiệu lực" prop="expiration_date" v-if="mData.dataForm.type == 'CONTRACT'">
                <el-date-picker
                  type="date"
                  ref="ExpirationDate"
                  v-model="mData.dataForm.expiration_date"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="false"
                  placeholder=""
                  prefix-icon="isax-calendar-1"
                  :format="'dd/MM/yyyy'"
                  @change="checkValidDate"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ghi chú" prop="description">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.description"
                  :disabled="mData.viewMode == 'detail'"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  clearable
                  @change="() => {mData.dataForm.description = mData.dataForm.description.trim()}"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Tệp" prop="file_ids">
                <el-upload
                  ref="upload"
                  :auto-upload="false"
                  list-type="text"
                  drag
                  action
                  :on-change="uploadFile"
                  :on-preview="previewFile"
                  :on-remove="removeFile"
                  :file-list="mData.fileUploadOption.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  multiple
                  :accept="mData.fileUploadOption.accept"
                >
                  <div v-if="mData.viewMode != 'detail'">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      <em>Click để tải lên</em>
                    </div>
                  </div>
                  <div class="el-upload__tip" style="font-style: italic" slot="tip">Chỉ tải file định dạng jpg, png, pdf, docx, doc và dung lượng không vượt quá 5MB</div>
                </el-upload>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer text-center">
        <el-button
        class="btn-back"
          @click="handleClose"
        >
          Bỏ qua
        </el-button>
        <el-button
          type="primary"
          @click="submitForm('create')"
          v-if="mData.viewMode == 'create'"
        >
          Thêm mới
        </el-button>
        <el-button
          type="primary"
          @click="submitForm('update')"
          v-if="mData.viewMode == 'update'"
        >
          Cập nhật
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ExtensionService from '../../../service/ExtensionService';
import DataService from '../../../service/DataService';
import MethodService from '../../../service/MethodService';
import LanguageService from '../../../service/LanguageService';
import ValidService from '../../../service/ValidService';
import EmployeeModel from '../../../views/admin/Employees/EmployeeModel';
import EmployeeApi from '../../../moduleApi/EmployeeApi';
import EmployeeContractApi from '../../../moduleApi/EmployeeContractApi';
import FileApi from '../../../moduleApi/FileApi';

export default {
  data() {
    return {
      MethodService,
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,

      mData: {
        moduleName: "Contract-Document",
        viewMode: "create",
        visibleDialog: false,
        dataForm: MethodService.copyObject(EmployeeModel.dataFormEmployeeContract),
        validForm: EmployeeModel.validFormEmployeeContract,
        tableRules: MethodService.copyObject(EmployeeModel.tableRulesEmployeeContract),
        companyInfo: undefined,
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listTypes: DataService.listTypeContractOrDocument,
          listEmployees: []
        },
        fileUploadOption: {
          accept: ".jpg, .png, .pdf, .docx, .doc",
          fileList: []
        }
      }
    }
  },
  methods: {
    syncContractValidationRules(){
      const codeRules = [ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(255)];
      if (this.mData.dataForm.type == 'CONTRACT') {
        codeRules.unshift(ValidService.required);
      }
      this.$set(this.mData.validForm, 'code', codeRules);
    },
    onTypeChange(){
      if (this.mData.dataForm.type == 'DOCUMENT') {
        this.mData.dataForm.code = undefined;
        this.mData.dataForm.effective_date = undefined;
        this.mData.dataForm.expiration_date = undefined;
      }
      this.syncContractValidationRules();
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate(["code", "effective_date", "expiration_date"]);
        }
      });
    },
    async initDataDefault(){
      try {
        const employeeApiReq = EmployeeApi.list({
          filters: "status!=DA_NGHI",
          limit: 9999999,
          sort: "administrative_info.name.first_name"
        });
        await Promise.all([
          employeeApiReq
        ]).then((promiseValue) => {
          this.mData.dataDefault.listEmployees = promiseValue[0].result;
        })
      } catch (error) {
        this.mData.dataDefault.listEmployees = [];
      }
    },
    async getDataEmployeeContract(){
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      this.$router
        .replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            ...dataFilter,
          },
        })
        .catch((err) => {});
      let employeeContractApiRes = await EmployeeContractApi.list(dataFilter);
      this.mData.tableRules.total = employeeContractApiRes.meta.total;
      if (employeeContractApiRes.result && employeeContractApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
          this.mData.tableRules.data = employeeContractApiRes.result;
      } else {
        this.mData.tableRules.data = [];
      }
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.getDataEmployeeContract();
      }
    },
    checkValidDate(){
      if (!this.mData.dataForm.effective_date || !this.mData.dataForm.expiration_date) return
      if (new Date(this.mData.dataForm.effective_date).getTime() > new Date(this.mData.dataForm.expiration_date).getTime()) {
        window.toastr.warning(`Ngày hết hiệu lực phải lớn hơn hoặc bằng ngày hiệu lực`);
        this.mData.dataForm.expiration_date = undefined;
        this.$refs['ExpirationDate'].focus();
      }
    },
    tableSearch(){
      this.$refs["saerchForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getDataEmployeeContract();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    handle(type, index, row){
      this.mData.viewMode = type;
      if (type == 'create') this.mData.visibleDialog = true;
      if (type == 'update') {
        this.getDataById(row.id);
        this.mData.visibleDialog = true;
      }
      if (type == 'delete') this.deleteContract(row.id);
      if (type == 'download') {
        this.$confirm(
          `Bạn có muốn tải tệp xuống? `,
          "Thông báo",
          {
            confirmButtonText: `Đồng ý`,
            cancelButtonText: "Hủy",
            type: "warning",
          }
        )
          .then(async () => {
            if (row.file_ids && row.file_ids.length == 1) {
              window.open(ExtensionService.urlDowloadFile + row.file_ids[0]);
            } else if (row.file_ids && row.file_ids.length > 1){
              ExtensionService.zipFile(row.file_ids, `${row.type == "CONTRACT" ? "HopDong" : "VanBan"}_${this.getEmployeeCode(row.employee_id)}`);
            }
          })
          .catch(() => {});
        }
    },
    async getDataById(id){
      const employeeContractRes = await EmployeeContractApi.findById(id);
      if (!employeeContractRes.result) return
      this.mData.dataForm = employeeContractRes.result;
      this.syncContractValidationRules();
      if (!this.mData.dataForm.file_ids) this.mData.fileUploadOption.fileList = []
      let listFile = await FileApi.list({
        limit: this.mData.dataForm.file_ids.length,
        filters: "id:in:" + this.mData.dataForm.file_ids.join(","),
      });
      this.mData.fileUploadOption.fileList = listFile.result.map(file => {
        file.url = ExtensionService.urlImg + file.id;
        return file;
      })
    },
    async deleteContract(id){
      this.$confirm(LanguageService.lang.c_deleteConfirm, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning"
      })
      .then(async () => {
        try {
          await EmployeeContractApi.delete(id);
          window.toastr.success("Xóa thành công");
          await this.getDataEmployeeContract();
        } catch (error) {
          window.toastr.error("Xóa không thành công");
        }
      })
    },
    handleClose(){
      this.mData.visibleDialog = false;
      this.resetForm();
    },
    async submitForm(type){
      this.$refs["myForm"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }
        let data = this.mData.dataForm;
        data.company_id = this.mData.companyInfo.id;
        if (data.type == "DOCUMENT") {
          // delete data.code;
          // delete data.effective_date;
          // delete data.expiration_date;
          data.code = null,
          data.effective_date = null;
          data.expiration_date = null;
        }
        try {
          if (type == "create") await EmployeeContractApi.create(data);
          if (type == "update") await EmployeeContractApi.update(data);
          window.toastr.success(`${type == "create" ? "Thêm mới" : "Cập nhật"} thành công`);
          this.handleClose();
          this.getDataEmployeeContract();
        } catch (error) {
          if (error.code != 500) {
            window.toastr.error(`${type == "create" ? "Thêm mới" : "Cập nhật"} không thành công`);
            return
          }
          window.toastr.error(`Mã số văn bản ${data.code} bị trùng, không thể ${type == "create" ? "thêm mới" : "cập nhật"}!`);
        }
      })
    },

    resetForm(){
      this.$refs["myForm"].resetFields();
      this.mData.fileUploadOption.fileList = [];
      this.mData.dataForm = MethodService.copyObject(EmployeeModel.dataFormEmployeeContract);
      this.syncContractValidationRules();
    },
    async uploadFile(file, fileList) {
      if (file && file.name) {
        let lastIndexOfDot = file.name.lastIndexOf(".");
        let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length);
        let typeImage = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
        if (!typeImage.includes(fileType.toLowerCase())) {
          window.toastr.warning("File không đúng định dạng");
          fileList.pop();
          return;
        }
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        window.toastr.warning("Dung lượng file tải lên tối đa là 5MB");
        fileList.pop();
        return;
      }
      ExtensionService.upload(file, "File_Hop_Dong")
        .then((res) => {
          this.mData.dataForm.file_ids.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    previewFile(file) {
      window.open(ExtensionService.urlDowloadFile + file.id);
    },
    removeFile(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.file_ids = data;
    },
    formatDate(date) {
      return MethodService.formatDate(date, "date");
    },
    getEmployee(id){
      let employee = this.mData.dataDefault.listEmployees.find(em => em.id == id);
      if (!employee) return
      return employee.administrative_info.name.full_name
    },
    getEmployeeCode(id){
      let employee = this.mData.dataDefault.listEmployees.find(em => em.id == id);
      if (!employee) return
      return employee.employee_no
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getDataEmployeeContract();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    },
  },
  async created() {
    await this.fn_hashUrl();
    this.mData.companyInfo = MethodService.getCompanyInfo();
    this.syncContractValidationRules();
    this.initDataDefault();
    this.getDataEmployeeContract();
  },
}
</script>

<style lang="scss" scoped>
// ::v-deep .el-upload-dragger {
//   height: 36px;
// }
</style>
